import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'pm-chat-markdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [MarkdownComponent],
  template: `<markdown
    class="block text-sm font-normal leading-relaxed text-content-default [overflow-wrap:anywhere] [&>:first-child]:mt-0 [&>:last-child]:mb-0 [&_a]:text-content-interactive-default [&_a]:underline [&_code]:rounded [&_code]:bg-surface-neutral-subdued [&_code]:px-1 [&_code]:py-px [&_code]:text-[13px] [&_h1]:mb-1.5 [&_h1]:mt-3 [&_h1]:text-base [&_h1]:font-semibold [&_h1]:text-content-title [&_h2]:mb-1.5 [&_h2]:mt-3 [&_h2]:text-[15px] [&_h2]:font-semibold [&_h2]:text-content-title [&_h3]:mb-1.5 [&_h3]:mt-3 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:text-content-title [&_li]:my-0.5 [&_ol]:mb-2.5 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:mb-2.5 [&_strong]:font-semibold [&_strong]:text-content-title [&_ul]:mb-2.5 [&_ul]:list-disc [&_ul]:pl-5"
    [data]="text()"
    (ready)="secureExternalLinks()"
  />`,
})
export class ChatMarkdownComponent {
  private readonly host = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly text = input.required<string>();

  protected secureExternalLinks(): void {
    const anchors =
      this.host.nativeElement.querySelectorAll<HTMLAnchorElement>('a[href]');
    anchors.forEach((anchor) => {
      anchor.target = '_blank';
      anchor.rel = 'noopener noreferrer';
    });
  }
}
